import React, { useEffect } from "react";
import "./ESComplianceStatusToggle.css";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";

export default function ESComplianceStatusToggle(props) {
  const handleStatus = (event, newStatus) => {
    props.setSelectedStatus(newStatus);
  };

  useEffect(() => {
    (async () => {
      try {
        let query;
        switch (props.selectedStatus) {
          case "Pass":
            query = {
              query: {
                nested: {
                  path: "OverallConvCompliance.Rules",
                  query: {
                    bool: {
                      must: [
                        {
                          match: {
                            "OverallConvCompliance.Rules.Status": "Success",
                          },
                        },
                      ],
                    },
                  },
                },
              },
            };
            break;
          case "Fail":
            query = {
              query: {
                nested: {
                  path: "OverallConvCompliance.Rules",
                  query: {
                    bool: {
                      should: [
                        {
                          match: {
                            "OverallConvCompliance.Rules.Status": "Response Timeout",
                          },
                        },
                        {
                          match: {
                            "OverallConvCompliance.Rules.Status": "Failure",
                          },
                        },
                      ],
                    },
                  },
                },
              },
            };
            break;
          default:
            query = props.defaultQuery;
            break;
        }

        props.setQuery(query);
      } catch (err) {}
    })();
  }, [props.selectedStatus]);

  return (
    <React.Fragment>
      <ToggleButtonGroup
        size="small"
        className="statusToggleButtonDiv"
        value={props.selectedStatus}
        exclusive
        onChange={handleStatus}
        aria-label="text alignment"
      >
        <ToggleButton className="toggleFirstButton" value="Pass" aria-label="left aligned">
          <span>Pass</span>
        </ToggleButton>
        <ToggleButton className="toggleLastButton" value="Fail" aria-label="right aligned">
          <span>Fail</span>
        </ToggleButton>
      </ToggleButtonGroup>
    </React.Fragment>
  );
}
